<template>
    <div class="remark-container">
        <div class="remark-title">
            <span>Remark</span>
        </div>
        <div class="remark-content">
            <el-form ref="remarkForm"
                     :model="remarkForm"
                     :rules="remarkFormRules"
                     label-position="top">
                <el-form-item label="English"
                              prop="remarkEN">
                    <quill-editor @change="onEditENChange"
                                  :options="quillOption"
                                  v-model="remarkForm.remarkEN"></quill-editor>
                </el-form-item>
                <el-form-item label="Chinese"
                              prop="remarkCN">
                    <quill-editor @change="onEditCNChange"
                                  :options="quillOption"
                                  v-model="remarkForm.remarkCN"></quill-editor>
                </el-form-item>
                <el-form-item label="French"
                              prop="remarkFR">
                    <quill-editor @change="onEditFRChange"
                                  :options="quillOption"
                                  v-model="remarkForm.remarkFR"></quill-editor>
                </el-form-item>
                 <el-form-item label="Arabic"
                              prop="remarkAR">
                    <quill-editor @change="onEditARChange"
                                  :options="quillOption"
                                  v-model="remarkForm.remarkAR"></quill-editor>
                </el-form-item>
                  <el-form-item label="Urdu"
                              prop="remarkUR">
                    <quill-editor @change="onEditURChange"
                                  :options="quillOption"
                                  v-model="remarkForm.remarkUR"></quill-editor>
                </el-form-item>
                <button class="subBtn"
                        @click.prevent="updateRemark">Submit</button>
            </el-form>
        </div>
    </div>
</template>
<script>
// import { quillEditor } from "vue-quill-editor"; // 导入quillEditor组件
import Sortable from 'sortablejs'
import api from '@api/cooperation'
import quillOption from '@config/quill-config'
export default {
    data () {
        return {
            remarkForm: {
                remarkCN: '',
                remarkEN: '',
                remarkFR: '',
                remarkAR: '',
                remarkUR: '',
                id: null
            },
            remarkFormRules: {
                remarkCN: [
                    { required: true, message: 'remark is required', trigger: 'change', pattern: '[^ \x22]+' }
                ],
                remarkEN: [
                    { required: true, message: 'remark is required', trigger: 'change', pattern: '[^ \x22]+' }
                ],
                remarkFR: [
                    { required: true, message: 'remark is required', trigger: 'change', pattern: '[^ \x22]+' }
                ],
                remarkAR: [
                    { required: true, message: 'remark is required', trigger: 'change', pattern: '[^ \x22]+' }
                ],
                 remarkUR: [
                    { required: true, message: 'remark is required', trigger: 'change', pattern: '[^ \x22]+' }
                ]
            },
            quillOption: quillOption,
        }
    },
    methods: {
        onEditENChange (e) {
            if (e.text.trim() == '') {
                this.remarkForm.remarkEN = ''
                this.$refs.remarkForm.validateField('remarkEN')
            } else {
                this.$refs.remarkForm.clearValidate('remarkEN')
            }
        },
        onEditCNChange (e) {
            if (e.text.trim() == '') {
                this.remarkForm.remarkCN = ''
                this.$refs.remarkForm.validateField('remarkCN')
            } else {
                this.$refs.remarkForm.clearValidate('remarkCN')
            }
        },
        onEditFRChange (e) {
            if (e.text.trim() == '') {
                this.remarkForm.remarkFR = ''
                this.$refs.remarkForm.validateField('remarkFR')
            } else {
                this.$refs.remarkForm.clearValidate('remarkFR')
            }
        },
         onEditARChange (e) {
            if (e.text.trim() == '') {
                this.remarkForm.remarkAR = ''
                this.$refs.remarkForm.validateField('remarkAR')
            } else {
                this.$refs.remarkForm.clearValidate('remarkAR')
            }
        },
          onEditURChange (e) {
            if (e.text.trim() == '') {
                this.remarkForm.remarkUR = ''
                this.$refs.remarkForm.validateField('remarkUR')
            } else {
                this.$refs.remarkForm.clearValidate('remarkUR')
            }
        },
        async fetchRemark () {
            const res = await api.queryRemark()
            this.remarkForm.remarkCN = res.data.remarkCN
            this.remarkForm.remarkEN = res.data.remarkEN
            this.remarkForm.remarkFR = res.data.remarkFR
            this.remarkForm.remarkAR = res.data.remarkAR
            this.remarkForm.remarkUR = res.data.remarkUR
            this.remarkForm.id = res.data.id
        },
        async updateRemark () {
            this.$refs.remarkForm.validate(async valid => {
                console.log(valid)
                if (valid) {
                    let params = {
                        "id": this.remarkForm.id,
                        "remarkCN": this.remarkForm.remarkCN,
                        "remarkEN": this.remarkForm.remarkEN,
                        "remarkFR": this.remarkForm.remarkFR,
                        "remarkAR": this.remarkForm.remarkAR,
                        "remarkUR": this.remarkForm.remarkUR,
                    }
                    const res = await api.insertOrUpdateRemark(params)
                    if (res.success == true) {
                        this.$message.success('Update successfully!')
                        this.fetchRemark()
                    }
                }
            })
        }
    },
    mounted () {
        this.fetchRemark()
    }
}
</script>
<style scoped>
.remark-container {
    margin-bottom: 20px;
    margin-top: 50px;
    margin-left: 250px;
}
.remark-title {
    padding: 20px;
    font-size: 22px;
    font-weight: 700;
    padding-left: 70px;
}
.remark-content {
    margin-left: 70px;
}
.remark-content >>> .ql-editor {
    height: 200px;
}
.el-form--label-top >>> .el-form-item__label {
    padding: 0px;
}
.subBtn {
    border: none;
    width: 130px;
    height: 40px;
    line-height: 40px;
    font-size: 22px;
    color: #fff;
    margin-top: 10px;
    background-color: #fe7b00;
    border-radius: 5px;
    box-shadow: 2px 2px 2px #ccc;
}
.remark-container >>> .el-form-item__content {
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/remark.vue